import React, { useMemo, useRef, useState } from "react";
import TopRightSemiCircular from "../assets/img/common/semi-circular-top-right.png";
import LeftSemiCircular from "../assets/img/common/semi-cicular-left.png";
import { ReactComponent as SearchIcon } from "../assets/img/common/search-icon.svg";
import Container from "../components/common/Container";
import { categories } from "../data/dataCheckboxes";
import { Bars, Oval } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import useFilterData from "../hooks/useFilterData";
import ResultCard from "../components/results/ResultCard";
import { useGetResultsQuery } from "../redux/slices/api/resultApiSlice";
import TagItem from "../components/common/TagItem";
import TagCheckbox from "../components/common/TagCheckbox";
import { useSelector } from "react-redux";
import { selectGeneral } from "../redux/slices/generalSlice";
import Pagination from "../components/common/Pagination";
import CustomCheckBox from "../components/common/CustomCheckBox";
import { FiFilter } from "react-icons/fi";
import ResultFilters from "../components/results/ResultFilters";
import MetaTags from "../components/common/MetaTags";
const Discovery = () => {
  // State variables for managing scroll data, current page, search value, and filter popup visibility
  const [scrollData, setScrollData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [showFiltersPopup, setShowFiltersPopup] = useState(false);

  // Ref to hold the timeout for search input
  const searchTimeoutRef = useRef(null);

  // Fetch discovery data using a query, including popular keywords and categories
  const { data: discoveryData, isLoading } = useGetResultsQuery();
  const { popular_keywords, popular_categories } = discoveryData ?? {};

  // Select general settings from the Redux store, including navbar visibility
  const { isHideNavbar } = useSelector(selectGeneral);

  // Get the current location and parse query parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const keywords = queryParams.get("keywords");
  const initialFilter = {
    search: "",
    keywords: keywords?.split(",") ?? [],
    category: [],
    projectState: [],
    premium: [],
    rangePrice: {},
  };

  // Functions to check filters against result items
  const checkSearch = (search, item) =>
    item?.title?.toLowerCase()?.includes(search.toLowerCase());
  const checkCategory = (category, item) =>
    category.some((i) => item?.types.includes(i));
  const checkKeywords = (keywords, item) =>
    item.keywords.some((key) => keywords.includes(key));
  const checkPremium = (premium, item) => premium.includes(item.premium);

  // Use the useFilterData hook to manage result filtering
  const {
    filteredData: filteredResults,
    filter,
    setFilter,
    handleChangeFilter,
    handleRemoveFilter,
  } = useFilterData({
    initialData: discoveryData?.results,
    initialFilter,
    initialDataLoading: isLoading,
    checkers: [
      {
        key: "search",
        checker: checkSearch,
      },
      {
        key: "category",
        checker: checkCategory,
      },
      {
        key: "keywords",
        checker: checkKeywords,
      },
      {
        key: "premium",
        checker: checkPremium,
      },
    ],
    // Scroll to the top when the filter changes
    onChangeFilter: () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setCurrentPage(1);
    },
  });

  // Update filter with keywords when the keywords change
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      keywords: keywords && keywords !== null ? keywords?.split(",") : [],
    }));
  }, [keywords]);

  // Add a scroll event listener to update the scroll data
  useEffect(() => {
    const handleScroll = () => {
      setScrollData(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to handle checkbox changes in the filter popup
  const handleChangeCheckBox = (e, property, value) => {
    e.target.checked
      ? handleChangeFilter({ [property]: value }, true)
      : handleRemoveFilter({ [property]: value });
  };

  // Number of results to display per page
  const pageSize = 10;

  // Calculate the current page of results using useMemo
  const currentResults = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredResults]);

  if (isLoading) {
    return (
      <div className="w-full min-h-screen flex justify-center items-center">
        <Bars
          height="50"
          width="50"
          color="#8538ff"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  } else
    return (
      <div
        className="w-full flex justify-center bg-no-repeat roboto-font  "
        style={{
          backgroundImage: `url(${TopRightSemiCircular}), url(${LeftSemiCircular})`,
          backgroundPosition: "top right, left top",
        }}
      >
        <MetaTags
          title="Discovery"
          description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
          link="/discovery"
        />
        <Container className="flex flex-col items-center pt-28 pb-10 ">
          {/* Modern Hero Section */}
          <div className="w-full mb-10 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
              Discover Research Results
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Explore cutting-edge scientific findings and breakthrough research from projects worldwide
            </p>
          </div>
          
          <div className="w-full flex justify-between gap-x-6 relative">
            {/* ////// filter input ///// */}
            <aside className="min-w-[290px] w-[30%] hidden lg:flex flex-col gap-4 items-center rounded-3xl pb-10 max-h-full ">
              <div className={`w-full flex flex-col sticky top-0 gap-4 `}>
                <section className="w-full max-h-[calc(100vh/2-90px)] hidden lg:flex flex-col items-center justify-between rounded-2xl bg-gradient-to-br from-white to-gray-50 pr-3 py-6 shadow-lg hover:shadow-xl transition-all duration-300">
                  <h3 className="text-2xl font-bold mb-6 w-full text-center abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
                    Popular Categories
                  </h3>
                  {isLoading ? (
                    <div className="w-full h-full flex justify-center items-center min-h-[200px]">
                      <Oval
                        height={40}
                        width={40}
                        color="#8538FF"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#8538FF"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                      />
                    </div>
                  ) : (
                    <div className="w-full flex flex-col gap-2 overflow-auto custom-primary-tiny-scroll px-3 ">
                      {popular_categories?.map((item, index) => (
                        <TagItem
                          key={item?.category + index}
                          id={item?.category}
                          title={item?.category}
                          count={item?.count}
                          icon={
                            categories?.find(
                              (cat) => cat.title === item?.category
                            )?.icon
                          }
                          onChange={(e) =>
                            handleChangeCheckBox(e, "category", item?.category)
                          }
                          checked={filter.category.includes(item?.category)}
                          index={index}
                          lblClass="w-full py-1.5"
                          containerClass="w-full"
                        />
                      ))}
                    </div>
                  )}

                  {/* ////////// */}
                </section>{" "}
                <section className="w-full max-h-[calc(100vh/2-90px)] hidden lg:flex flex-col items-center justify-between rounded-2xl bg-gradient-to-br from-white to-gray-50 pr-3 py-6 shadow-lg hover:shadow-xl transition-all duration-300">
                  <h3 className="text-2xl font-bold mb-6 w-full text-center abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
                    Popular Keywords
                  </h3>
                  {isLoading ? (
                    <div className="w-full h-full flex justify-center items-center min-h-[200px]">
                      <Oval
                        height={40}
                        width={40}
                        color="#8538FF"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#8538FF"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                      />
                    </div>
                  ) : (
                    <div className="w-full flex items-center flex-wrap gap-3 overflow-auto custom-primary-tiny-scroll px-3 ">
                      {popular_keywords?.map((item, index) => (
                        <TagCheckbox
                          key={item?.keyword + index}
                          id={item?.keyword}
                          title={item?.keyword}
                          count={item?.count}
                          onChange={(e) =>
                            handleChangeCheckBox(e, "keywords", item?.keyword)
                          }
                          checked={filter.keywords.includes(item?.keyword)}
                          index={index}
                          lblClass="py-1.5"
                          containerClass=""
                        />
                      ))}
                    </div>
                  )}
                  {/* ////////// */}
                </section>{" "}
                <section className="w-full max-h-[calc(100vh/2-90px)] hidden lg:flex flex-col items-center justify-between rounded-2xl bg-gradient-to-br from-white to-gray-50 px-4 py-6 shadow-lg hover:shadow-xl transition-all duration-300">
                  <h3 className="text-2xl font-bold mb-6 w-full text-center abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
                    Result Type
                  </h3>
                  {isLoading ? (
                    <div className="w-full h-full flex justify-center items-center min-h-[200px]">
                      <Oval
                        height={40}
                        width={40}
                        color="#8538FF"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#8538FF"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                      />
                    </div>
                  ) : (
                    <div className="w-full flex justify-between ">
                      <CustomCheckBox
                        id={"public"}
                        title={"Public"}
                        lblClass="h-9"
                        containerClass="w-1/2 mr-2"
                        checked={filter?.premium?.includes(false)}
                        onChange={(e) =>
                          handleChangeCheckBox(e, "premium", false)
                        }
                      />
                      <CustomCheckBox
                        id={"premium"}
                        title={"Premium"}
                        lblClass="h-9"
                        containerClass="w-1/2"
                        checked={filter?.premium?.includes(true)}
                        onChange={(e) =>
                          handleChangeCheckBox(e, "premium", true)
                        }
                      />
                    </div>
                  )}
                  {/* ////////// */}
                </section>{" "}
              </div>
            </aside>
            {/* ////////////////////// */}
            <section className="w-full flex flex-col roboto-font pb-5 ">
              <div className={`w-full pb-6 sticky top-0 z-10 `}>
                <div
                  className={`w-full flex items-center justify-between bg-gradient-to-br from-white to-gray-50 rounded-2xl px-6 py-5 shadow-lg gap-x-3 hover:shadow-xl transition-all duration-300`}
                >
                  <div className="w-full h-14 rounded-xl bg-white shadow-sm flex items-center justify-between px-6 p-1 focus-within:shadow-md focus-within:ring-2 focus-within:ring-primary/20 transition-all duration-300">
                    <SearchIcon className="text-gray-400" />
                    <input
                      type="search"
                      className="footer-email-input placeholder:text-gray-400 h-full bg-transparent w-full pl-4 pr-6 font-[poppins] text-base"
                      placeholder="Search research results..."
                      onChange={(e) => {
                        let value = e.target.value;
                        clearTimeout(searchTimeoutRef.current);
                        setSearchValue(value);
                        searchTimeoutRef.current = setTimeout(
                          () => {
                            handleChangeFilter({ search: e.target.value });
                          },
                          value?.length ? 1000 : 0
                        );
                      }}
                      value={searchValue}
                    />
                  </div>{" "}
                  <button
                    onClick={() => setShowFiltersPopup(true)}
                    className="min-w-fit lg:hidden flex items-center poppins-font font-semibold text-primary hover:text-[#7e7cff] transition-colors duration-300"
                  >
                    <FiFilter size={22} className="mr-2" />
                    FILTER
                  </button>
                </div>
              </div>
              {/* /////// cards ///////// */}
              <div className="w-full rounded-3xl pb-1">
                <div className="w-full grid grid-cols-1 gap-y-5 py-1">
                  {currentResults?.length ? (
                    currentResults?.map((item) => (
                      <ResultCard
                        resultData={item}
                        projectData={item?.project}
                        isOnDiscovery
                        key={item?._id}
                      />
                    ))
                  ) : (
                    <div className="w-full flex flex-col justify-center items-center py-20">
                      <div className="w-20 h-20 rounded-full bg-gradient-to-r from-gray-100 to-gray-200 flex items-center justify-center mb-4">
                        <SearchIcon className="w-10 h-10 text-gray-400" />
                      </div>
                      <span className="text-2xl font-bold text-gray-700 mb-2">No results found</span>
                      <span className="text-gray-500">Try adjusting your search or filter criteria</span>
                    </div>
                  )}{" "}
                </div>{" "}
              </div>

              {filteredResults?.length ? (
                <div className="w-full flex justify-center mt-3">
                  <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={filteredResults?.length}
                    pageSize={pageSize}
                    onPageChange={(page) => setCurrentPage(page)}
                  />{" "}
                </div>
              ) : null}
            </section>{" "}
          </div>
        </Container>
        {/* /////// filter popup ///////// */}
        {showFiltersPopup && (
          <ResultFilters
            show={showFiltersPopup}
            setShow={setShowFiltersPopup}
            discoveryData={discoveryData?.results}
            isLoading={isLoading}
            handleChangeCheckBox={handleChangeCheckBox}
            handleChangeFilter={handleChangeFilter}
            handleRemoveFilter={handleRemoveFilter}
            filter={filter}
            setFilter={setFilter}
            initialFilter={initialFilter}
            popular_categories={popular_categories}
            popular_keywords={popular_keywords}
          />
        )}
      </div>
    );
};

export default Discovery;
